jQuery( function ($) {

   
	if ( typeof gform != 'object' ) { return; }

	// improved gform ajax spinner
	$(document).on( 'submit', '.gform_wrapper form', function () {
		let $button = $( 'button[type=submit]', this );
		if ( !$button.length ) { return; }
		$button.attr( 'disabled', true );
		$button.attr( 'aria-disabled', 'true' );
		$button.addClass( 'is-ajax-submitting' );
	});


	$(document).on( 'gform_post_render', function ( e, form_id, current_page ) {
		$( 'select', `#gform_${ form_id }` ).each( function () {
			ThemeJS.Functions.init_select2( this );
		});
		observe_size( form_id );
	});


	// #region resize-obs
	const gf_obs = new ResizeObserver( entries => {
		for ( let entry of entries ) {
			set_inline_submit_styles( $( entry.target ) );
			$( '.gfield_error', entry.target ).each( set_error_position );
		}
	});

	function observe_size ( form_id ) {
		$( `form#gform_${ form_id } .gform_fields` ).each( function () {
			gf_obs.observe( this );
		})
	}

	function set_inline_submit_styles ( $gfields ) {
		const $submit = $( '.gfield--width-fill + .gfield--type-submit', $gfields );
		if ( $submit.length ) {
			const $filled = $submit.prev();
			$filled.addClass( 'btn-inline' );
			$filled.toggleClass( 'btn-inline', ( $submit.get(0).offsetTop == $filled.get(0).offsetTop ) );
		}
	}

	function set_error_position () {
		// scoped to .gfield
		$(this).css( '--input-container-top', `${ $( '.ginput_container', this ).get(0).offsetTop }px` );
	}
	// #endregion


    // #region uploads
	const file_icon_types = {
		'csv': [ 'csv' ],
		'pdf': [ 'pdf' ],
		'zipper': [ 'zip' ],
		'excel': [ 'xls', 'xlsx' ],
		'word': [ 'doc', 'docx' ],
		'image': [ 'png', 'jpg', 'jpeg' ],
	};

	function get_file_fa_class ( ext ) {
		const type = Object.keys( file_icon_types ).reduce( ( type, key ) => {
			return ( !type && file_icon_types[ key ].includes( ext ) ) ? key : type;
		}, null );
		return ['fa', 'file', type ].filter( x => x ).join('-');
	}

	function get_gfile_preview ( file, actions ) {
		const ext = ThemeJS.Functions.get_extension( file.name );
		const display_name = ext ? file.name.substring( 0, file.name.lastIndexOf( '.' ) ) : file.name;
		return `
			<span class='ftype fas ${ get_file_fa_class( ext ) }'></span>
			<div class='details'>
				<div>${ display_name }</div>
				<div class='filesize'>${ ThemeJS.Functions.format_bytes( file.size ) }</div>
			</div>
			${ actions }
		`;
	}

	// file being added, during upload
	gform.addFilter( 'gform_file_upload_status_markup', function ( html, file, size, strings, removeFileJs, up ) {
		const btn = `
			<div class='actions'>
				<span class="gfield_fileupload_progress">
					<span class="gfield_fileupload_progressbar">
						<span class="gfield_fileupload_progressbar_progress"></span>
					</span>
					<span class="gfield_fileupload_percent"></span>
					<div class='cancel'>
						<button type='button' class='btn btn-link link-danger' onclick="${ removeFileJs }">${ strings.cancel }</button>
					</div>
				</span>
			</div>
		`;
		return `<div id='${ file.id }' class='ginput_preview'>${ get_gfile_preview( file, btn ) }</div>`;
	});

	// upload finished
	gform.addFilter('gform_file_upload_markup', function ( html, file, up, strings, imagesUrl, response) {
		const btn = `
			<button type='button' class='actions gform_delete_file btn btn-danger' onclick='gformDeleteUploadedFile(${ up.settings.multipart_params.form_id }, ${ up.settings.multipart_params.field_id }, this)'>
				<span class='icon fas fa-trash' aria-hidden='true'></span>
				<span class='screen-reader-text'>${ strings.delete_file }: ${ file.name }</span>
			</button>
		`;
		return get_gfile_preview( file, btn );
	});

	// trigger multifile browse open on click of droparea
	$( document ).on( 'click', '.gform_drop_area', function ( e ) {
		if ( !$( e.target ).closest( 'button' ).length ) {
			$( 'button', this ).click();
		}
	});

	// drag/drop events for single files
	$( document ).on( 'dragenter', '.single-file-wrap', function ( e ) {
		if ( !$.contains( this, e.relatedTarget ) ) {
			this.style.setProperty( `--input-z`, 1 );
		}
	});
	$( document ).on( 'dragleave drop', '.single-file-wrap', function ( e ) {
		if ( !$.contains( this, e.relatedTarget ) ) {
			this.style.removeProperty( `--input-z` );
		}
	});

	$( document ).on( 'change', '.gfield input[type=file]:not([multiple])', function () {
		const $display = $(this).closest( '.single-file-wrap' ).find( '.selected-file' );
		$display.text( $( this ).val().split('\\').pop().split('/').pop() );
	});
	// #endregion

});